import { RESUME_FORMAT_LINE, RESUME_GOOGLE_DOC_LINE } from "../lib/resumeUpload";

// Shown beside every resume upload button. Same words everywhere.
export default function ResumeUploadHint({ className = "", style, testId = "resume-upload-hint" }) {
  return (
    <div className={className} style={style} data-testid={testId}>
      <p data-testid={`${testId}-formats`} style={{ margin: 0 }}>{RESUME_FORMAT_LINE}</p>
      <p data-testid={`${testId}-google-doc`} style={{ margin: "2px 0 0" }}>{RESUME_GOOGLE_DOC_LINE}</p>
    </div>
  );
}
